import styled from "styled-components"

export const StyledDropDown = styled.div`
  width: 270px;
`